// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CalculatorFilledSvg from "@ant-design/icons-svg/es/asn/CalculatorFilled";
import AntdIcon from '../components/AntdIcon';

var CalculatorFilled = function CalculatorFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CalculatorFilledSvg
  }));
};

CalculatorFilled.displayName = 'CalculatorFilled';
export default React.forwardRef(CalculatorFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CalculatorFilled.js
// module id = 701
// module chunks = 0